import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  hardReset,
  reportProcessData,
  reportProcessList,
  reportDetailsGet,
  clearBroadcastBufferReport
} from '../../../store/slices/tenantSlices/realtimeReportSlice';

import HardResetConfirmationModal from './HardResetConfirmationModal';
import AdminHeader from '../../../components/header/AdminHeader';
import FormSelect from '../../../components/form/FormSelect';
import { refreshTimeOptions } from '../../../utils/common';
import ProcessDetails from './ProcessDetails';
import BroadcastReportCount from './BroadcastReportCount';
import BroadcastReportList from './BroadcastReportList';
import ClearBufferConfirmationModal from './ClearBufferConfirmationModal';

const BroadcastReport = () => {
  const dispatch = useDispatch();

  const [processId, setProcessId] = useState('');
  const [hyperProcessId, setHyperProcessId] = useState('');
  const [refreshTime, setRefreshTime] = useState(5);
  const [processOptions, setProcessOptions] = useState([]);
  const [proData, setProData] = useState([]);
  const [countData, setCountData] = useState([]);
  const [listData, setListData] = useState([]);
  const [hardResetModalOpen, setHardResetModalOpen] = useState(false);
  const [bufferClearModalOpen, setBufferClearModalOpen] = useState(false);

  const getProcessList = async () => {
    try {
      const response = await dispatch(reportProcessList()).unwrap();
      const options =
        response && response.data.length > 0
          ? response.data.map((item) => ({ label: item.process_name, value: item.process_id }))
          : [];
      setProcessOptions([{ label: 'All', value: '' }, ...options]);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getProcessData = async () => {
    try {
      const payload = {
        selected_process_id: processId || undefined
      };
      const response = await dispatch(reportProcessData(payload)).unwrap();
      if (response && response?.data && response?.data?.length > 0) {
        setProData(response.data);
      } else {
        setProData([]);
      }
    } catch (error) {
      setProData([]);
      console.log('error', error);
    }
  };

  const onBufferClear = async () => {
    try {
      const response = await dispatch(
        clearBroadcastBufferReport({
          selected_process_id: hyperProcessId ? hyperProcessId : processId ? processId : undefined
        })
      ).unwrap();
      toast.success(response?.message);
      setBufferClearModalOpen(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getReportDetailsData = async (process_id) => {
    try {
      const payload = {
        selected_process_id: process_id || undefined
      };
      const response = await dispatch(reportDetailsGet(payload)).unwrap();
      if (response && response?.count_data && response?.count_data?.length > 0) {
        setCountData(response.count_data);
      } else {
        setCountData([]);
      }
      if (response && response?.data && response?.data?.length > 0) {
        setListData(response.data);
      } else {
        setListData([]);
      }
    } catch (error) {
      setCountData([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    getProcessList();
  }, []);

  useEffect(() => {
    const fetchData = () => {
      const id = hyperProcessId ? hyperProcessId : processId;
      getProcessData();
      getReportDetailsData(id);
    };

    fetchData();

    if (refreshTime) {
      const intervalId = setInterval(fetchData, refreshTime * 1000);

      return () => clearInterval(intervalId);
    }
  }, [refreshTime, processId, hyperProcessId]);

  const onHardReset = async () => {
    try {
      const response = await dispatch(hardReset()).unwrap();
      toast.success(response?.message);
      setHardResetModalOpen(false);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Fragment>
      <AdminHeader title="Voice Broadcast Realtime Report" />
      <Row>
        <Col lg="2" md="2" className="px-2">
          <Card className="mb-3 px-2 py-1">
            <Row>
              <Col lg="12" md="12">
                <FormSelect
                  isShowLabel={false}
                  name="processId"
                  value={processId}
                  placeholder="Select Process"
                  options={processOptions}
                  onChange={(e) => {
                    setProcessId(e.target.value);
                    setHyperProcessId('');
                  }}
                />
              </Col>
              {/* <Col lg="12" md="12">
                <Button
                  color="primary"
                  className="px-4 w-100"
                  type="submit"
                  onClick={() => setHardResetModalOpen(true)}>
                  Hard Reset
                </Button>
              </Col> */}
            </Row>
          </Card>
          <Card className="m-0 broadcast-process-details">
            <ProcessDetails
              data={proData}
              setHyperProcessId={setHyperProcessId}
              activeId={hyperProcessId ? hyperProcessId : processId}
            />
          </Card>
        </Col>
        <Col lg="10" md="10">
          <Row>
            <Col lg="9" md="9">
              <Card className="p-2 m-0">
                <BroadcastReportCount data={countData} />
              </Card>
            </Col>
            <Col lg="3" md="3" className="px-2">
              <Card className="mb-3 px-2 py-2">
                <Row>
                  <Col lg="12" md="12">
                    <FormSelect
                      isShowLabel={false}
                      name="refreshTime"
                      value={refreshTime}
                      placeholder="Select Refresh"
                      options={refreshTimeOptions}
                      onChange={(e) => setRefreshTime(e.target.value)}
                    />
                  </Col>
                  <Col lg="12" md="12">
                    <Button
                      color="primary"
                      className="px-4 w-100"
                      type="submit"
                      onClick={() => setBufferClearModalOpen(true)}>
                      Clear Buffer
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col lg="12" md="12">
              <Card className="p-2 m-0">
                <BroadcastReportList data={listData} />
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      <ClearBufferConfirmationModal
        isOpen={bufferClearModalOpen}
        onClearClick={() => onBufferClear()}
        onCloseClick={() => setBufferClearModalOpen(false)}
      />
      <HardResetConfirmationModal
        isOpen={hardResetModalOpen}
        onResetClick={() => onHardReset()}
        onCloseClick={() => setHardResetModalOpen(false)}
      />
    </Fragment>
  );
};

export default BroadcastReport;
